import script from "./VueCommandQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./VueCommandQuery.vue?vue&type=script&setup=true&lang=js"

import "./VueCommandQuery.vue?vue&type=style&index=0&id=b4dd2f7e&lang=scss"

const __exports__ = script;

export default __exports__